import { memo, forwardRef } from "react";
import DatePicker from "react-datepicker";
import clsx from "clsx";
import "react-datepicker/dist/react-datepicker.css";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import styles from "./DatePicker.module.scss";

interface IDatePickerProps {
  rightLabel?: string;
  leftLabel?: string;
  selected: Date | null;
  handleChange?: (date: Date | null) => void;
  handleChangeRange?: (date: [Date | null, Date | null]) => void;
  includedDates?: Date[];
  className?: string;
  iconClassName?: string;
  startDate?: Date | null;
  endDate?: Date | null;
  maxDate?: Date;
  selectsRange?: true;
  disabled?: boolean;
  isClearable?: boolean;
}
   
export const CustomDatePicker = memo(
  ({
    rightLabel,
    leftLabel,
    selected,
    handleChange,
    handleChangeRange,
    includedDates,
    className,
    iconClassName,
    startDate,
    endDate,
    maxDate,
    selectsRange,
    disabled = false,
    isClearable = false,
  }: IDatePickerProps) => {
    const CalendarButton = forwardRef<HTMLDivElement, { onClick?: () => void }>(
      ({ onClick }, ref) => (
        <div
          style={{ borderRadius: "5px", height: "24px" }}
          className={clsx(styles.overlayLabel, styles.overlayButton, className)}
          onClick={!disabled ? onClick : () => {}}
          ref={ref}
        >
          {leftLabel}
          <CalendarMonthRoundedIcon
            className={clsx(styles.icon, iconClassName)}
          />
          {rightLabel}
        </div>
      )
    );

    if (disabled) {
      return <CalendarButton />;
    }

    return (
      // @ts-ignore
      <DatePicker
        selected={selected}
        onChange={
          selectsRange
            ? (dates) =>
                handleChangeRange?.(dates as [Date | null, Date | null])
            : (date) => handleChange?.(date as Date | null)
        }
        customInput={<CalendarButton />}
        popperPlacement="top"
        popperClassName={styles.calendar}
        showPopperArrow={false}
        includeDates={includedDates}
        startDate={startDate ?? undefined}
        endDate={endDate ?? undefined}
        selectsRange={selectsRange}
        maxDate={maxDate}
        isClearable={isClearable}
        clearButtonClassName={styles.clearButton}
      />
    );
  }
);
